<template>
  <a-layout-content class="content-wrapper">
    <bread-crumb />
    <router-view />
  </a-layout-content>
</template>

<script>
import BreadCrumb from '@/components/BreadCrumb'

export default {
  name: 'CustomStyleContentWrapper',
  components: { BreadCrumb }
}
</script>

<style lang="less" scoped>
.content-wrapper {
  padding: 16px 16px 30px;
  overflow: auto;
  height: calc(100vh - 64px);
  flex: none;
}
</style>
